module.exports = __webpack_public_path__ + "img/home2.ff4d56ea.jpg";